import { gql } from '@apollo/client';
import { CONNECTION_PRICE_MATRIX_FRAGMENT } from '../../lib/core/fragments';
import { CURRENT_SUBSCRIPTION_FRAGMENT } from '../../lib/core/fragments/currentSubscription';

export const BUY_GIFT_CARD_PAGE_QUERY = gql`
  ${CONNECTION_PRICE_MATRIX_FRAGMENT}

  fragment BuyGiftCardProduct on Product {
    id
    descriptionText
    name
    price
    extendedRentalPeriodCharge
    tripStartCharge
    rentalMeterType
    campaign
    slug {
      current
    }
    connectionPriceMatrixes {
      ...ConnectionPriceMatrix
    }
  }
  query buyGiftCardPageQuery(
    $systemId: ID
    $locale: String
    $productSlug: String!
    $fetchProduct: Boolean!
  ) {
    products(
      systemId: $systemId
      locale: $locale
      giftable: true
      channel: web
    ) {
      ...BuyGiftCardProduct
    }
    productBySlug(slug: $productSlug) @include(if: $fetchProduct) {
      ...BuyGiftCardProduct
    }
    buyGiftCardPage(systemId: $systemId, locale: $locale) {
      title
      heading
      emailCaption
    }
  }
`;

export const PLACE_ANON_VALUE_CODE_ORDER = gql`
  mutation placeAnonymousValueCodeOrderMutation(
    $orderLines: [OrderLineInput!]!
    $customerEmail: String!
    $receiptEmail: String
  ) {
    placeAnonymousValueCodeOrder(
      orderLines: $orderLines
      customerEmail: $customerEmail
      receiptEmail: $receiptEmail
    ) {
      ... on Order {
        id
        token
      }
      ... on AnonymousValueCodeOrderError {
        errorCode
      }
    }
  }
`;

export const PLACE_VALUE_CODE_ORDER = gql`
  mutation placeValueCodeOrderMutation(
    $orderLines: [OrderLineInput!]!
    $customerEmail: String!
    $receiptEmail: String
  ) {
    placeValueCodeOrder(
      orderLines: $orderLines
      customerEmail: $customerEmail
      receiptEmail: $receiptEmail
    ) {
      ... on Order {
        id
        token
      }
      ... on ValueCodeOrderError {
        errorCode
      }
    }
  }
`;

export const PAY_GIFT_CARD_ORDER_CHECKOUT_MUTATION = gql`
  mutation payGiftCardOrderCheckoutMutation(
    $orderId: ID!
    $paths: PaymentPaths!
    $paymentMethodType: PaymentMethodType
  ) {
    payOrderCheckout(
      orderId: $orderId
      paths: $paths
      paymentMethodType: $paymentMethodType
    ) {
      ... on CheckoutSessionStripe {
        sessionId
        publishableKey
      }
      ... on CheckoutSessionPayex {
        redirectUrl
      }
      ... on CheckoutSessionNevogate {
        redirectUrl
      }
    }
  }
`;

export const PAY_GIFT_CARD_ORDER_CHARGE_MUTATION = gql`
  ${CURRENT_SUBSCRIPTION_FRAGMENT}
  mutation payGiftCardOrderChargeMutation($orderId: ID!) {
    payOrderCharge(orderId: $orderId) {
      __typename
      ... on ChargeCompletedSubscription {
        subscription {
          ...CurrentSubscription
        }
      }
      ... on ConfirmationSessionStripe {
        clientSecret
        paymentMethodRef
        publishableKey
        paymentDocument {
          ... on InvoiceTrip {
            token
          }
          ... on InvoiceFine {
            token
          }
          ... on Order {
            token
          }
        }
      }
      ... on ChargeCompleted {
        paymentDocument {
          ... on InvoiceTrip {
            token
          }
          ... on InvoiceFine {
            token
          }
          ... on Order {
            token
          }
        }
      }
      ... on ChargePending {
        paymentDocument {
          ... on InvoiceTrip {
            token
          }
          ... on InvoiceFine {
            token
          }
          ... on Order {
            token
          }
        }
      }
      ... on PaymentIntentError {
        description
        errorCode
        message
      }
    }
  }
`;
